// ** React Imports
import React, { useContext, useMemo } from 'react'
import { Outlet } from "react-router-dom"

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"

// ** Menu Items Array
import navigation from "@src/navigation/vertical"

import { AuthContext } from '@context/AuthContext'

const VerticalLayout = (props) => {
    const { isAdmissionUser, userDetail } = useContext(AuthContext)

    const cNavigation = useMemo(() => {
        return (
            navigation?.filter((menus) => isAdmissionUser ? menus?.id === "BoardingHouse" : menus)

            // // Түр бүгдэд дотуур байрыг л харуулсан
            // (!isAdmissionUser && userDetail?.student?.code === 'AMM23D045')
            // ?
            // navigation
            // :
            // navigation?.filter((menus) => menus?.id === "BoardingHouse")
        )
    }, [isAdmissionUser])

    return (
        <Layout menuData={cNavigation} {...props}>
            <Outlet />
        </Layout>
    )
}

export default VerticalLayout
